export default {
  e872e57859137b9c84c27ff9c2230147: 'Promotional product information has been exposed',
  '2e559a40fe029a2702aeed075f3256df': 'Promotional product detail page',
  '02720b8439d76730d67ea9cb43b756ee': 'Promotional product details page - SKU selection drawer',
  '40f43d921074fb0050380b9910a31fb6':
    'This product is temporarily unavailable for purchase. Please contact customer service',
  '92a4ff217a99a6c97c0f9477856e8424': 'Product details page - SKU Selection drawer - OK button',
  '910cc2fc89535112bd266203330673dd': 'Product Details page - SKU Selection drawer',
  '8f77677f7d83d20616d63dfa5138f85a': 'List',
  '73795c41fdd34539c6b6d212d23434da':
    'This product is a limited-purchase item. You do not meet the purchase limit conditions and thus cannot make a purchase',
  '53997ca1844bc56d2361c1da72e52a0e': 'Has been taken off the shelves',
  '036d62c422933dee566f3ecc15d9d7cc': 'Sold out',
  '89b7c80030a72d3ba23cfa9e0c35278d': 'Buy now',
  eca3fb3bb9f6673181a8c1e1586bd32e: 'Log in to view offers',
  '0bcf854077294bb13c657aef880cc9a7': 'Sign a contract for free',
  '589b70dbda8407a46ccb11cf1c43c11c': 'Select product',
  '2084df2c35a80a4c531debec35f87e51': 'Get Coupon & Buy',
  '7d099309d4d95bc67e510882069e797f': 'Product detail page - Purchase button',
  '87de92da2b65bb09107389426c8469e1': 'Parameter error!',
  '2f5e2bb9287717ab4cf4d22be52459c2':
    'The final price may differ due to regional tax regulations. Please check the payment page for the exact amount.',
  '047ca3c31efc5217d3c7febb7580a5e3': 'Learn first, pay later',
  d420c6711b060379f9b4fb379dc91547: 'Quarterly Payment',
  d672ee75696f853f98f954c65eab47dc: 'Share',
  a1473119c045c63c7cb34506501762cb: '"Delivery',
  '29ea6e058ff28e2a3677734159ffe9ac': 'Express delivery',
  b8e4b0eb658162bfccbc2de7292f12ef: 'Explanation',
  c3a078a756214810b29b06fa3d6443f6: 'Product detail page - Customer service button',
  cb865d32020146363bdb5c99a6e809bd: 'Chat'
};
